import { Component } from '@angular/core';
import { Location } from '@angular/common';

@Component({
  templateUrl: './not-found.component.html'
})
export class NotFoundComponent {
  today = new Date();

  constructor(private location: Location) { }

  back() {
    this.location.back();
  }

}
